import { PositionMsgType } from "./types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const PopupContent: React.FC<{ p: PositionMsgType; labels?: Partial<Record<"pos"|"msg"|"save"|"hdop","string">> }> = ({ p, labels }) => {
  const L = {
    pos: labels?.pos ?? "Position Time",
    msg: labels?.msg ?? "Message Time",
    save: labels?.save ?? "Message Save Time",
    hdop: labels?.hdop ?? "HDOP",
  };
  const fmt = (v?: string|number|Date) => v ? dayjs(v).utc().format("DD/MM/YYYY HH:mm:ss") : "Unknown";
  return (
    <div className="here-map-tooltip">
      <div><strong>{L.pos}:</strong><br/>{fmt(p.gpsTimestamp)}</div><br/>
      <div><strong>{L.msg}:</strong><br/>{fmt(p.messageTimestamp)}</div><br/>
      <div><strong>{L.save}:</strong><br/>{fmt(p.timeSaved)}</div><br/>
      <div><strong>{L.hdop}</strong><br/>{p.hdop ?? "Unknown"}</div>
    </div>
  );
};
